import { render, staticRenderFns } from "./languageSetAdmin.vue?vue&type=template&id=5bb2d2a0"
import script from "./languageSetAdmin.vue?vue&type=script&lang=js"
export * from "./languageSetAdmin.vue?vue&type=script&lang=js"
import style0 from "./languageSetAdmin.vue?vue&type=style&index=0&id=5bb2d2a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports